import React from 'react';
import __ from 'lodash';

class DdKelas extends React.Component{
    render(){
        return (
            this.props.kelas.map((val) =>
                <option key={val.id_kelas} value={val.id_kelas}>{val.alias_kelas}</option>
            )            
        )
    }
}

export default DdKelas;